import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { graphql } from 'react-apollo';
import PropTypes from 'prop-types';
import { Form, Icon, Input, Button } from 'antd';
import displayServerErrors from '../../../utilities/form/display_server_errors';
import { createToken } from './mutations/createToken';
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import { PeekPasswordButton } from '../../common/peekPasswordButton/peekPasswordButton';
import './form.css';

const FormItem = Form.Item;

class LoginForm extends Component {
  static propTypes = {
    mutate: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { loading: false, passwordType: 'password' };
  }

  get mutationParams() {
    return {
      variables: {
        input: {
          ...this.props.form.getFieldsValue(),
          forbidden_roles: ['ChurchMember']
        }
      }
    }
  }

  async submitData() {
    try {
      this.setState({ loading: true });
      localStorage.removeItem('authenticationToken');
      const { data } = await this.props.mutate(this.mutationParams);
      localStorage.setItem('authenticationToken', data.createToken.token);
      this.props.onSubmit(data.createToken.current_user);
    } catch(response) {
      displayServerErrors(this.props.form, response, { 'base': 'email' });
    } finally {
      this.setState({ loading: false });
    }
  }

  onSubmit = (event) => {
    event.preventDefault();

    this.props.form.validateFields((error, _values) => {
      if (!error) {
        this.submitData();
      }
    });
  };

  showHidePassword = (event) => {
    event.preventDefault();
    event.stopPropagation();

    this.setState({ passwordType: this.state.passwordType === 'input' ? 'password' : 'input' })
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form onSubmit={this.onSubmit} className="login-form">
        <h1 className="login-form__header">Welcome to SOW Evangelism Pastor page!</h1>
        <FormItem>
          {getFieldDecorator('email', {
            rules: [
              { required: true, message: 'Please enter your email' }
            ],
          })(
            <Input prefix={<Icon type="mail" style={{ fontSize: 13 }} />} placeholder="Username" />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('password', {
            rules: [
              { required: true, message: 'Please enter your password' }
            ],
          })(
            <Input prefix={<Icon type="lock" style={{ fontSize: 13 }} />}
                   suffix={<PeekPasswordButton passwordType={this.state.passwordType} onClick={this.showHidePassword}/>}
                   type={this.state.passwordType}
                   placeholder="Password" />
          )}
        </FormItem>
        <FormItem>
          <Button type="primary" htmlType="submit" className="login-form__login-button" loading={this.state.loading}>
            <b>LOG IN</b>
          </Button>
        </FormItem>
        <FormItem className="login-form__forgot-password-item">
          <Link to={"/auth/reset_password_request"}>I can't log in</Link>
        </FormItem>
      </Form>
    );
  }
}

export default Form.create()(graphql(createToken, {
  options: {
    update: (proxy, { data: { createToken } }) => {
      proxy.writeQuery({ query: getCurrentUser, data: { current_user: createToken.current_user } });
    }
  }
})(LoginForm));



// WEBPACK FOOTER //
// ./src/components/pages/login/form.js